import React from 'react';
import { getTranslations } from '../translations';
import NotFound from '../components/NotFound';

interface EmptyInterface {
  ulid ?: string;
}

export const Empty : React.FC<EmptyInterface> = ({ulid}) => {
  const { error_messages: { "favourites": translations }, labels : {share} } = getTranslations();

  // const inventoryCookie = inventoryCookies.get(inventoryFavourites) || [];
  // const hasOwnFavourites = !!inventoryCookie?.id && !!inventoryCookie?.vins?.length;

  // const getEmptyCopy = () => {
  //   return replaceStringWithJSX(share.empty.scenario_1, {
  //     own_favourites: <CTA tag="a" href="/favourites" emphasis="tertiary"> {share.empty.here} </CTA>
  //   });
  // };

  // const sharedSubhead = !hasOwnFavourites ? `${share.empty.copy} ${getEmptyCopy()}` : `${share.empty.copy} ${share.empty.scenario_2}`;

  return (
    <NotFound
      header={!ulid ? translations.header : share.empty.title}
      subhead={!ulid ? share.copy.empty : `${share.empty.copy} ${share.empty.scenario_2}`}
      copy={translations.cta}
    />
  );
};
